import React, { useEffect, useLayoutEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useRecoilState, useRecoilValue } from 'recoil';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Fade } from 'react-awesome-reveal';
import {
	languageSetting,
	translatedText,
} from '../../recoil-states/language-state';

import '../../css/gallery.css';
import SearchForm from '../../component/SearchForm';
import SortDropdown from '../../component/SortDropdown';
import {
	_getNftMarketCategoryHeaderList,
	_getNftMarketCategoryList,
	_getCurrencyList,
	_getNftMarketSortList,
	_getGalleryCategoryList,
	_getGallerySortList,
	_getGalleryCategoryHeaderList,
	_getGalleryData,
} from '../../function/functions';
import CategoryHeader from '../../component/CategoryHeader';
import Header from '../../component/header';
import Footer from '../../component/Footer';
import FilterCategoryButton from '../../component/FilterCategoryButton';
import ListItem from '../../component/ListItem';
import RefreshListButton from '../../component/RefreshListButton';

import dogh from '../../assets/dogh.png';
import filterOpenButton from '../../assets/filter-arrow.svg';
import PageUpButton from '../../component/PageUpButton';
import galleryM from '../../assets/gallery_m.svg';
import konnectM from '../../assets/konnect_m2.svg';
import { OAuthData } from '../../recoil-states/user-state/user-OAuth';
import BoxDetailModal from '../../component/detailModal/BoxDetailModal';

export default function Gallery({ windowWidth, handleAuth }) {
	const [language] = useRecoilState(languageSetting);
	const textData = useRecoilValue(translatedText);

	const [galleryData, setGalleryData] = useState([]);
	const [page, setPage] = useState(1);
	const [isLastPage, setIsLastPage] = useState(false);
	const [totalItems, setTotalItems] = useState(0);

	const [selectedCategoryMain, setSelectedCategoryMain] = useState('');
	const [selectedCategorySub, setSelectedCategorySub] = useState('');
	const [selectedSort, setSelectedSort] = useState('');
	const [searchValue, setSearchValue] = useState('');

	const [categoryAllList, setCategoryAllList] = useState({});
	const [categoryMainList, setCategoryMainList] = useState([]);
	const [categoryHeaderData, setCategoryHeaderData] = useState({});
	const [sortList, setSortList] = useState([]);
	const [refreshing, setRefreshing] = useState(false);
	const [openToggle, setOpenToggle] = useState(true);
	const userData = useRecoilValue(OAuthData);

	const [cardData, setCardData] = useState([]);

	useLayoutEffect(() => {
		setRefreshing(true);
		const categoryAllListData = _getGalleryCategoryList(language);
		const categoryMainListData = Object.keys(categoryAllListData);
		const sortListData = _getGallerySortList(language);
		const categoryHeaderData_data = _getGalleryCategoryHeaderList(language);

		setCategoryAllList(categoryAllListData);
		setCategoryMainList(categoryMainListData);
		setCategoryHeaderData(categoryHeaderData_data);
		setSortList(sortListData);

		setSelectedCategoryMain(categoryMainListData[0]);
		setSelectedSort(sortListData[0]);
	}, [language]);

	useLayoutEffect(() => {
		if (Object.keys(categoryAllList).length > 0) {
			setRefreshing(true);
			setSelectedCategorySub(categoryAllList[selectedCategoryMain][0]);
		}
	}, [selectedCategoryMain]);

	useLayoutEffect(() => {
		if (
			selectedCategoryMain &&
			selectedCategoryMain.length > 0 &&
			selectedCategorySub &&
			selectedCategorySub.length > 0
		) {
			setCardData([]);
			setRefreshing(true);
			_fetchGalleryData(selectedCategoryMain, selectedCategorySub, 1);
		}
	}, [selectedCategoryMain, selectedCategorySub]);

	/**
	 * 갤러리 Data 업데이트
	 * @param {string} category
	 * @param {string} subCategory
	 * @param {number} page
	 * @param {boolean} isRefresh
	 * @function _fetchGalleryData
	 * @returns {state} CardData
	 * @returns {state} page
	 * @returns {state} isLastPage
	 * @returns {state} totalItems
	 * @returns {state} Refreshing
	 */

	function _fetchGalleryData(category, subCategory, page, isRefresh = false) {
		const result = _getGalleryData(category, subCategory, page);
		setCardData(prev => {
			if (result.data.edition) {
				if (
					prev.length > 0 &&
					(isRefresh ||
						result.data[result.data.length - 1].edition ===
							prev[prev.length - 1].edition)
				) {
					return [...prev];
				}
			}
			return prev.concat(result.data);
		});
		setPage(page);
		setIsLastPage(result.isLastPage);
		setTotalItems(result.totalItems);
		setRefreshing(false);
	}

	const animationProps = {
		delay: 1000,
		duration: 1200,
	};
	/**
	 * sub탭에 선택된 값 리턴
	 * @author ydw <teammapa.ydw@gmail.com>
	 * @function selectMenu
	 * @returns {string} CategorySub
	 */

	const selectMenu = () => {
		if (selectedCategorySub === 'Tori' || selectedCategorySub === '푸들') {
			return 'poodle';
		} else if (
			selectedCategorySub === 'Andre' ||
			selectedCategorySub === '불독'
		) {
			return 'bulldog';
		} else if (
			selectedCategorySub === 'Collin' ||
			selectedCategorySub === '보더콜리'
		) {
			return 'collin';
		} else if (
			selectedCategorySub === 'Dove' ||
			selectedCategorySub === '도베르만'
		) {
			return 'doberman';
		} else if (
			selectedCategorySub === 'KM' ||
			selectedCategorySub === '진도'
		) {
			return 'km';
		} else if (
			selectedCategorySub === 'SHILLA Platinum NFT CARD' ||
			selectedCategorySub === '신라 플래티넘 NFT CARD'
		) {
			return 'booldog_image';
		}
	};
	/**
	 * sub탭에 선택된 값에 따라 string 리턴
	 * @param {string} text
	 * @author ydw <teammapa.ydw@gmail.com>
	 * @function selectMenu
	 * @returns {string}
	 */

	const _subText = text => {
		if (text === 'Tori' || text === '푸들') {
			return '3% have this trait';
		} else if (text === 'Collin' || text === '보더콜리') {
			return '7% have this trait';
		} else if (text === 'Dove' || text === '도베르만') {
			return '13% have this trait';
		} else if (text === 'KM' || text === '진도') {
			return '27% have this trait';
		} else if (text === 'Andre' || text === '불독') {
			return '50% have this trait';
		} else {
			return '';
		}
	};

	return (
		<>
			{windowWidth > 1024 ? (
				<>
					<HelmetProvider>
						<Helmet>
							<link
								rel='stylesheet'
								type='text/css'
								href='./css/gallery_background.css'
							/>
						</Helmet>
					</HelmetProvider>
					<Container fluid id='gallery'>
						<Header handleAuth={handleAuth} />
						<Row className='intro-container'>
							<Col className='intro__title-container' md={7}>
								<Fade
									delay={1e3}
									damping={0.1}
									cascade
									className='intro__title-container_reveal'
									triggerOnce
								>
									Konnect NFT
								</Fade>
								<Fade
									delay={1e3}
									damping={0.1}
									cascade
									className='intro__title-container_reveal'
									triggerOnce
								>
									Gallery
								</Fade>
							</Col>
							<Col className='intro__nameCard-container' md={5}>
								<Row>
									<Col
										className='intro__nameCard__text-container'
										md={9}
									>
										<Fade
											direction='top-right'
											{...animationProps}
											triggerOnce
										>
											<span>
												1st Konnect NFT Marketplace{' '}
												<br />
												Creative Director
												<span className='accent'>
													{' '}
													Vincent van Dogh
												</span>
											</span>
										</Fade>
									</Col>
									<Col
										className='intro__nameCard__picture-container'
										md={3}
									>
										<Fade
											direction='top-right'
											{...animationProps}
											triggerOnce
										>
											<img
												src={dogh}
												alt='Vincent van Dogh'
											/>
										</Fade>
									</Col>
								</Row>
							</Col>
						</Row>
						<Row className='main-container'>
							<Col className='filter-container' lg={3}>
								{categoryMainList.map((item, index) => {
									return (
										<div key={index}>
											<Row
												className='filter__header'
												onClick={e => {
													setOpenToggle(!openToggle);
													setSelectedCategoryMain(
														item
													);
													if (
														selectedCategoryMain !==
														item
													) {
														setOpenToggle(true);
													}
												}}
											>
												<Col>
													<div>
														<span>{item}</span>
													</div>
													<div className='rotate_icons'>
														<img
															src={
																filterOpenButton
															}
															alt='open and close filter'
															style={{
																transform:
																	selectedCategoryMain !==
																		item ||
																	!openToggle
																		? 'rotate(270deg)'
																		: 'rotate(360deg)',
																transition:
																	'0.5s',
															}}
														/>
													</div>
												</Col>
											</Row>
											{openToggle ? (
												<Row
													className='filter__content'
													style={{
														transform:
															selectedCategoryMain !==
															item
																? 'translateY(-100%)'
																: 'translateY(0)',
														display:
															selectedCategoryMain !==
															item
																? 'none'
																: 'block',
														// maxHeight :
														//   selectedCategoryMain !== item
														//   ? "0px"
														//   : "fit-content",
													}}
												>
													<Col>
														{categoryAllList[
															item
														].map(
															(
																subItem,
																index
															) => {
																return (
																	<FilterCategoryButton
																		key={
																			subItem
																		}
																		text={
																			subItem
																		}
																		subText={_subText(
																			subItem
																		)}
																		isSelected={
																			selectedCategorySub ===
																			subItem
																		}
																		onClick={() => {
																			setSelectedCategorySub(
																				subItem
																			);
																		}}
																	/>
																);
															}
														)}
													</Col>
												</Row>
											) : null}
										</div>
									);
								})}
							</Col>
							<Col className='contents-container'>
								{Object.keys(categoryHeaderData).length > 0 && (
									<CategoryHeader
										categoryHeaderData={categoryHeaderData}
										category={selectedCategoryMain}
									/>
								)}
								{/* 임시 주석 시작 */}
								{/* <Row className="search-container">
                        <Col className="search__form-container" sm={12} md={9}>
                            <SearchForm
                                inputId="gallery-search"
                                placeholder={language === 'ko'? "검색어를 입력하세요" : "Search by name or trait"}
                                value={searchValue}
                                onChange={e => {setSearchValue(e.target.value)}}
                            />
                        </Col>
                        <Col className="search__sort-container" sm={12} md={3}>
                            <SortDropdown
                                list={sortList}
                                value={selectedSort}
                                setValue={setSelectedSort}
                            />
                        </Col> 
                    </Row> 
                    <Row className="contents__display-items-sum">
                        <Col>                                                 
                            <RefreshListButton
                                itemsCount={totalItems}
                                onClick={() => {
                                        setRefreshing(true);
                                        setTimeout(() => {
                                            _fetchGalleryData(
                                                selectedCategoryMain, 
                                                selectedCategorySub, 
                                                page,
                                                language,
                                                true
                                            );
                                        }, 500);
                                    }}
                                refreshing={refreshing}
                            />
                        </Col>
                    </Row> */}
								{/* 임시 주석 끝 */}
								<Row className='contents'>
									{/* 일반 div로 바꿀 수도 있음 */}
									{cardData.length ? (
										// devidedGalleryData.map(chunkArr => {
										//     return (
										//         <Row
										//             key={chunkArr[0].id}
										//             className="contents__content-row"
										//         >
										//             {
										//                 chunkArr.map(item => (
										//                     <Col
										//                         key={`${item.category}-${item.id}-${item.name}`}
										//                         className="contents__content-row__col" md={12}
										//                         lg={6}
										//                         xl={4}
										//                     >
										//                         <ListItem
										//                             itemData={item}
										//                             language={language}
										//                         />
										//                     </Col>
										//                 ))
										//             }
										//         </Row>
										//     )
										// })
										<Row className='contents__content-row'>
											{cardData.map((item, index) => {
												return (
													<Col
														key={index}
														className='contents__content-row__col'
														md={12}
														lg={6}
														xl={4}
													>
														<ListItem
															itemData={item}
															category={
																selectedCategoryMain
															}
															language={language}
															img_text={selectMenu()}
															text={
																selectedCategorySub
															}
														/>
													</Col>
												);
											})}
										</Row>
									) : (
										<div className='no-contents'>
											<h1>
												{
													textData.gallery[
														'Comming Soon'
													]
												}
											</h1>
											<h3>
												{
													textData.gallery[
														'Comming Soon Detail'
													]
												}
											</h3>
										</div>
									)}
								</Row>
								<Row className='contents-continue-button-container'>
									{!isLastPage && (
										<PageUpButton
											onClick={() => {
												_fetchGalleryData(
													selectedCategoryMain,
													selectedCategorySub,
													page + 1,
													language
												);
											}}
										/>
									)}
								</Row>
							</Col>
						</Row>
					</Container>
				</>
			) : (
				// Mobile 반응형
				<>
					<Header handleAuth={handleAuth} />
					<HelmetProvider>
						<Helmet>
							<link
								rel='stylesheet'
								type='text/css'
								href='./css/gallery_background.css'
							/>
						</Helmet>
					</HelmetProvider>
					<div className='gallery_header_m'>
						<img src={konnectM} />
						<img src={galleryM} />
					</div>
					<Container fluid id='gallery'>
						<Col className='filter-container' lg={3}>
							{categoryMainList.map((item, index) => {
								return (
									<>
										<Row
											key={index}
											className='filter__header filter_herder_m'
											onClick={() => {
												setOpenToggle(!openToggle);
												setSelectedCategoryMain(item);
												if (
													selectedCategoryMain !==
													item
												) {
													setOpenToggle(true);
												}
											}}
										>
											<Col className='toggle_menu_m'>
												{/* css 수정 */}
												<div>
													<span>{item}</span>
												</div>
												<div
													style={{
														display: 'flex',
														justifyContent:
															'center',
														alignItems: 'center',
													}}
												>
													<img
														src={filterOpenButton}
														alt='open and close filter'
														style={{
															transform:
																selectedCategoryMain !==
																	item ||
																!openToggle
																	? 'rotate(270deg)'
																	: 'rotate(360deg)',
															transition: '0.5s',
														}}
													/>
												</div>
											</Col>
										</Row>
									</>
								);
							})}
							<Col className='contents-container'>
								{Object.keys(categoryHeaderData).length > 0 && (
									// css 수정
									<CategoryHeader
										categoryHeaderData={categoryHeaderData}
										category={selectedCategoryMain}
									/>
								)}
							</Col>
							{categoryMainList.map((item, index) => {
								return (
									<>
										{openToggle ? (
											<Row
												key={index}
												className='filter__content'
												style={{
													transform:
														selectedCategoryMain !==
														item
															? 'translateY(-100%)'
															: 'translateY(0)',
													display:
														selectedCategoryMain !==
														item
															? 'none'
															: 'block',
												}}
											>
												<Col>
													{categoryAllList[item].map(
														subitem => {
															return (
																<FilterCategoryButton
																	key={
																		subitem
																	}
																	text={
																		subitem
																	}
																	subText={_subText(
																		subitem
																	)}
																	isSelected={
																		selectedCategorySub ===
																		subitem
																	}
																	onClick={() => {
																		setSelectedCategorySub(
																			subitem
																		);
																	}}
																/>
															);
														}
													)}
												</Col>
											</Row>
										) : null}
									</>
								);
							})}
						</Col>
						<Row className='contents'>
							{cardData.length ? (
								<Row className='contents__content-row'>
									{cardData.map(item => {
										return (
											<Col
												key={item.edition}
												className='contents__content-row__col'
												md={12}
												lg={6}
												xl={4}
											>
												<ListItem
													itemData={item}
													category={
														selectedCategoryMain
													}
													language={language}
													img_text={selectMenu()}
													text={selectedCategorySub}
												/>
											</Col>
										);
									})}
								</Row>
							) : (
								<div className='no-contents'>
									<h1>{textData.gallery['Comming Soon']}</h1>
									<h3>
										{
											textData.gallery[
												'Comming Soon Detail'
											]
										}
									</h3>
								</div>
							)}
						</Row>
						<Row className='contents-continue-button-container'>
							{!isLastPage && (
								<PageUpButton
									onClick={() => {
										_fetchGalleryData(
											selectedCategoryMain,
											selectedCategorySub,
											page + 1
										);
									}}
								/>
							)}
						</Row>
					</Container>
				</>
			)}
			<Footer backgroundColor='transparent' />
		</>
	);
}
